module.exports = __webpack_public_path__ + "static/esthederm-957ed315922d7df844a7a4e52b917c33.jpg";